import Carousel from "framer-motion-carousel";
import { useEffect, useState } from "react";
import ArrowLeftCarousel from "~/assets/icons/ArrowLeftCarousel";

export function CarouselClient({
    images,
    control,
    content,
}: {
    images: Array<any>;
    control?: JSX.Element;
    content?: JSX.Element;
}) {
    const isMobile = useIsMobile();

    return (
        <div id="CarouselHome" className="carousel slide" data-ride="carousel">
            <Carousel
                renderDots={({ activeIndex, setActiveIndex }) => (
                    <ol className="carousel-indicators">
                        {images.map((_, i) => (
                            <li
                                key={i}
                                onClick={() => setActiveIndex(i)}
                                data-target="#CarouselHome"
                                data-slide-to={i}
                                className={`${activeIndex === i ? "active" : ""}`}
                            />
                        ))}
                    </ol>
                )}
                renderArrowLeft={({ handlePrev }) => (
                    <div className="carousel-control" data-slide="prev" onClick={handlePrev}>
                        {control ?? (
                            <div className="default">
                                <ArrowLeftCarousel />
                            </div>
                        )}
                    </div>
                )}
                renderArrowRight={({ handleNext }) => (
                    <div className="carousel-control right" data-slide="next" onClick={handleNext}>
                        {control ?? (
                            <div className="default">
                                <ArrowLeftCarousel />
                            </div>
                        )}
                    </div>
                )}
                interval={8000}
            >
                {images.map((item) => (
                    <div key={item.src} className="carousel-inner">
                        <div className="item active">
                            {!item.showButton && item.imageUrl ? (
                                <a
                                    href={item.imageUrl}
                                    style={{ display: "block", width: "100%", height: "100%" }}
                                >
                                    {renderImage(item, isMobile)}
                                </a>
                            ) : (
                                renderImage(item, isMobile)
                            )}

                            {content ?? (
                                <div className="carousel-caption">
                                    {item.h2?.text !== undefined ? (
                                        item.h2.text.trim() !== "" ? (
                                            <h2 style={{ color: item.h2?.color || "inherit" }}>
                                                {item.h2.text}
                                            </h2>
                                        ) : null
                                    ) : (
                                        item.h2 && <h2>{item.h2}</h2>
                                    )}

                                    {item.logo && (
                                        <img
                                            className="carousel-logo"
                                            src={item.logo}
                                            alt="Logo"
                                            onError={(e) => {
                                                (e.target as HTMLImageElement).src =
                                                    "/assets/images/FallbackImageCarousel.png";
                                            }}
                                        />
                                    )}

                                    {item.p?.text !== undefined ? (
                                        item.p.text.trim() !== "" ? (
                                            <p style={{ color: item.p.color || "inherit" }}>
                                                {item.p.text}
                                            </p>
                                        ) : null
                                    ) : (
                                        item.p && <p>{item.p}</p>
                                    )}

                                    {item.showButton && (
                                        <a href={item.url} className="btn-carousel">
                                            {item.a}
                                        </a>
                                    )}
                                </div>
                            )}
                        </div>
                    </div>
                ))}
            </Carousel>
        </div>
    );
}

function renderImage(item: any, isMobile: boolean) {
    const hasMobile = item?.mobile && item.mobile !== "";
    const imageClass = `CarouselHome__img--desktop ${isMobile && !hasMobile ? "mobile-src" : ""}`;

    return (
        <picture>
            {hasMobile && <source media="(max-width: 1024px)" srcSet={item.mobile} />}
            <img
                className={imageClass}
                draggable="false"
                src={isMobile && hasMobile ? item.mobile : item.src}
                alt=""
                style={{ display: "block", width: "100%" }}
                onError={(e) => {
                    (e.target as HTMLImageElement).src = "/assets/images/FallbackImageCarousel.png";
                }}
            />
        </picture>
    );
}

function useIsMobile(breakpoint = 1024) {
    const isBrowser = typeof window !== "undefined";
    const [isMobile, setIsMobile] = useState(() => {
        return isBrowser ? window.innerWidth <= breakpoint : false;
    });

    useEffect(() => {
        if (!isBrowser) return;

        const handleResize = () => {
            setIsMobile(window.innerWidth <= breakpoint);
        };

        window.addEventListener("resize", handleResize);
        return () => window.removeEventListener("resize", handleResize);
    }, [breakpoint]);

    return isMobile;
}
